module.exports = __webpack_public_path__ + "img/E248.e2223e27.svg";